export class UploadFile {
    public type: number;
    public file: File;
}
